export default function noop() {}



// WEBPACK FOOTER //
// ./src/Tooltip/js/utils/noop.js


// WEBPACK FOOTER //
// webpack:///src/Tooltip/js/utils/noop.js